import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { moveToFavoritesEvent } from 'events/cart';

import { cartIsLoading, changeQuantity } from 'actions/cart';
import { heartProduct } from 'actions/hearts';
import { toUSD } from 'helpers/NumberFormats';
import CartQuantityDropdown from 'components/cart/CartQuantityDropdown';
import ProductImage from 'components/cart/ProductImage';
import { SmallLoader } from 'components/Loader';
import ItemDescription from 'components/cart/ItemDescription';
import FinalSale from 'zen/components/common/FinalSale';
import css from 'styles/components/cart/cartItem.scss';

export class CartItem extends Component {
  static contextTypes = {
    testId: PropTypes.func,
    marketplace: PropTypes.object,
    router: PropTypes.object
  };

  static propTypes = {
    item: PropTypes.object.isRequired
  };

  state = {
    updating: null
  };

  onItemUpdate = asin => {
    this.props.cartIsLoading();
    this.setState({ updating: asin });
  }

  onItemUpdateDone = () => {
    this.setState({ updating: null });
  };

  onMoveToFavorites = ({ currentTarget }) => {
    const {
      changeQuantity,
      heartProduct,
      moveToFavoritesEvent,
      isCustomer,
      isModal
    } = this.props;

    const {
      router,
      marketplace: { authUrl }
    } = this.context;

    const { asin } = currentTarget.dataset;

    if (isCustomer) {
      this.onItemUpdate(asin);
      const itemData = { asin, quantity: 0 };

      const callback = () => {
        moveToFavoritesEvent(asin);
        changeQuantity({ 'items': [itemData] });
      };

      // don't refetch heart lists when inside a cart modal
      heartProduct({ subItemId: asin }, callback, { shouldFetchHeartList: !isModal });
    } else {
      router.push(`${authUrl}/cart`);
    }
  }

  makeCartActions = () => {
    const {
      hasFullDetails = true,
      item,
      isUnavailable,
      showFixedQuantity,
      hideFavorite = false
    } = this.props;

    const { marketplace: { checkout: { allowMoveToFavorites } } } = this.context;

    if (!hasFullDetails) {
      return null;
    }

    const { testId } = this.context;

    const { asin, egc } = item;

    return (
      <div className={css.actions}>
        { !!showFixedQuantity && <><span className={css.fixedQuantity}>Quantity:</span> {showFixedQuantity}</> }

        {
          !showFixedQuantity && <CartQuantityDropdown
            isUnavailable={isUnavailable}
            item={item}
            onChangeQuantityCb={this.onItemUpdate}
            onChangeQuantityCbDone={this.onItemUpdateDone} />
        }

        { (!hideFavorite && allowMoveToFavorites && !(egc || isUnavailable))
          && <button
            type="button"
            className={css.moveToFavs}
            onClick={this.onMoveToFavorites}
            data-test-id={testId('moveToFavoritesButton')}
            data-asin={asin}>Move to <span>Favorites</span></button> }
      </div>
    );
  };

  makePrice = ({ price, originalPrice, finalSale }, stock, isUnavailable) => {
    const { testId } = this.context;
    if (isUnavailable) {
      return (
        <em className={css.unavailable} data-test-id={testId('unavailable')}>Unavailable</em>
      );
    }

    const isDiscounted = originalPrice > price;

    return (
      <>
        <em className={cn(css.price, { [css.discount]: isDiscounted })} data-test-id={testId('price')}>{toUSD(stock * price)}</em>
        { isDiscounted && <span>MSRP: {toUSD(stock * originalPrice)}</span>}
        { stock !== 1 && <span className={css.each}>{toUSD(price)} each</span> }
        { finalSale && <FinalSale /> }
      </>
    );
  }

  render() {
    const {
      item,
      isUnavailable,
      addedStockId,
      className,
      children,
      isFavorite = false,
      isModal = false,
      isRecommendedFit = false
    } = this.props;

    const { updating } = this.state;

    const { testId } = this.context;

    const { egc, asin, stockId, quantity = 1 } = item;

    const stock = isFavorite ? 1 : quantity;

    const testIdName = egc ? 'giftCardItem' : isFavorite ? 'favItem' : 'cartItem';

    return (
      <div
        data-test-id={testId(testIdName)}
        className={cn(className, css.container, {
          [css.favorite]: isFavorite,
          [css.compress]: isModal,
          [css.fade]: addedStockId && addedStockId === stockId
        })}>
        { asin === updating && <div className={css.updating}><SmallLoader /></div> }
        <ProductImage item={item} className={css.image} />
        <div className={css.midColumn}>
          <ItemDescription
            isUnavailable={isUnavailable}
            isModal={isModal}
            item={item}
            isRecommendedFit={isRecommendedFit}
          />

          { this.makeCartActions() }

          <div className={css.priceContainer}>
            { children }
            { this.makePrice(item, stock, isUnavailable) }
          </div>
        </div>

      </div>
    );
  }
}

export function mapStateToProps(state) {
  const { cart: { addedStockId } , cookies } = state;
  const isCustomer = !!cookies['x-main'];

  return {
    addedStockId,
    isCustomer
  };
}

export default connect(mapStateToProps, {
  cartIsLoading,
  changeQuantity,
  moveToFavoritesEvent,
  heartProduct
})(CartItem);
